import type { CSSProperties } from "react";

import type { TenantCode } from "@/config/tenants";

export interface TenantPresentation {
  readonly authContentAlignment?: "center" | "start";
  readonly fontFamily: string;
  readonly structure: string;
  readonly structureForeground: string;
}

export const tenantPresentationConfigurations: Partial<Record<TenantCode, TenantPresentation>> = {
  "12connex": {
    authContentAlignment: "center",
    fontFamily: "var(--font-inter)",
    structure: "#0f2537",
    structureForeground: "#ffffff",
  },
};

type TenantPresentationStyle = CSSProperties & {
  "--tenant-structure"?: string;
  "--tenant-structure-foreground"?: string;
};

export function tenantPresentationToStyle(presentation?: TenantPresentation): TenantPresentationStyle {
  if (!presentation) {
    return {};
  }

  return {
    "--tenant-structure": presentation.structure,
    "--tenant-structure-foreground": presentation.structureForeground,
    fontFamily: presentation.fontFamily,
  };
}
